export function formatWorkflowConditions(
  conditions,
  attributes,
  getConditionDropdownValues
) {
  return conditions.map(condition => {
    const attr = attributes.find(a => a.key === condition.attribute_key);

    if (!attr) {
      return condition;
    }

    const inputType = attr.inputType;

    if (inputType === 'plain_text' || inputType === 'date') {
      return {
        ...condition,
        values: condition.values?.[0] ?? '',
      };
    }

    if (inputType === 'comma_separated_plain_text') {
      return {
        ...condition,
        values: (condition.values || []).join(','),
      };
    }

    const options = getConditionDropdownValues(condition.attribute_key) || [];

    const matched = options.filter(item =>
      (condition.values || []).includes(item.id)
    );

    return {
      ...condition,
      query_operator: condition.query_operator || 'and',
      values: matched,
    };
  });
}
